export const getWindow = () => (typeof window === 'undefined' ? undefined : window);
